(function () {
  var pdplatformThemeConfig = function ($mdThemingProvider, $rootScope) {
    $mdThemingProvider.definePalette('pdplatform-primary', {
      '50': 'e0ecfe',
      '100': 'b3d0fe',
      '200': '80b1fd',
      '300': '4d91fc',
      '400': '267afb',
      '500': '0062fa',
      '600': '005af9',
      '700': '0050f9',
      '800': '0046f8',
      '900': '0034f6',
      'A100': 'ffffff',
      'A200': 'eaedff',
      'A400': 'b7c2ff',
      'A700': '9dacff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('pdplatform-accent', {
      '50': 'e0ecfe',
      '100': 'b3d0fe',
      '200': '80b1fd',
      '300': '4d91fc',
      '400': '267afb',
      '500': '0062fa',
      '600': '005af9',
      '700': '0050f9',
      '800': '0046f8',
      '900': '0034f6',
      'A100': 'ffffff',
      'A200': 'eaedff',
      'A400': 'b7c2ff',
      'A700': '9dacff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '400',
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('pdplatform-warn', {
      '50': 'fae9e5',
      '100': 'f3c7bd',
      '200': 'eba291',
      '300': 'e27c65',
      '400': 'dc6044',
      '500': 'd64423',
      '600': 'd13e1f',
      '700': 'cc351a',
      '800': 'c62d15',
      '900': 'bc1f0c',
      'A100': 'ffeae8',
      'A200': 'ffbbb5',
      'A400': 'ff8c82',
      'A700': 'ff7569',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('pdplatform')
      .primaryPalette('pdplatform-primary')
      .accentPalette('pdplatform-accent', { 'default': '500' })
      .warnPalette('pdplatform-warn', { 'default': '500' });
  };

  pdplatformThemeConfig.$inject = ['$mdThemingProvider'];
  angular.module('ecap').config(pdplatformThemeConfig);

  var pdplatformThemeRun = function ($rootScope) {
    if (!$rootScope.$themes) {
      $rootScope.$themes = {};
    }
    $rootScope.$themes['pdplatform'] = {
      primaryColor: '#233967',
      accentColor: '#1d84f5'
    };
  };

  pdplatformThemeRun.$inject = ['$rootScope'];
  angular.module('ecap').run(pdplatformThemeRun);
})();